import { primaryFadeGreen, frenchPass, springRain, gainsboro } from "../../../lib/colors";

export const ChartColors = {
  green: primaryFadeGreen,
  orange: "#f8d3d3",
  purple: "#ead6fb",
  blue: frenchPass,

  ates: "#ffca76",
  pending: "#fffa76",
  queued: "#ffeab0",
  accepted: "#BAFFC9",
  rejected: "#ff7676",
  undelivered: "#fcd5d6",
  blocked: "#ff7f76",
  expired: "#9ba3ba",
  unprocessed: "#aeaeae",
  processed: "#9acfef",
  delivered: "#8ee4d7",
  counter: "#6A8CAF",
  smscOdd: "#fcd5d6",
  smscEven: "#7188b3",
  smsSubmit: frenchPass,
  smsDelivered: "#ead6fb",
  msgProcessed: "#e8d7f9",

  singleMsg: "#0dcaf0",
  bulkMsg: springRain,

  otpColor: "#1E2A5E",
  transaction: "#7C93C3",
  advertising: "#E2BFD9",
  country1: gainsboro,
  country2: "#BAFFC9",
  country3: "#BAE1FF",
  country4: "#E6A9EC",
  country5: "#FFB2D9",
  sender1: "#FFC3A0",
  sender2: "#A0C3FF",
  sender3: "#C3FFA0",
  sender4: "#D3A0FF",
  sender5: "#A0FFE1",

  singleColor: "sage",
  broadNet: "teal",
  seller: "cyan",
  unitedArab: "beige",
  jordan: "maroon",
  samer: "brown",
};
